import { useEffect, useRef } from 'react';
import MessageBubble from './MessageBubble';
import ChatInput from './ChatInput';
import ModeSelector from './ModeSelector';
import PersonaToggle from './PersonaToggle';

export default function ChatWindow({
  messages,
  streaming,
  onSend,
  conversationId,
  persona,
  onPersonaChange,
  mode,
  onModeChange,
  voiceSupported,
  onVoiceGesture,
  onStartVoice,
}) {
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <div className="flex flex-col h-[calc(100vh-8rem)] md:h-[calc(100vh-4rem)]">
      <PersonaToggle
        conversationId={conversationId}
        currentPersona={persona}
        onChange={onPersonaChange}
      />
      <ModeSelector
        mode={mode}
        onChange={onModeChange}
        voiceSupported={voiceSupported}
      />
      <div className="flex-1 overflow-y-auto px-4 py-4">
        {messages.map((msg) => (
          <MessageBubble key={msg.id} message={msg} />
        ))}
        {streaming && messages[messages.length - 1]?.content === '' && (
          <div className="flex justify-start mb-4">
            <div className="bg-white dark:bg-gray-900 rounded-2xl px-4 py-3 border border-gray-200 dark:border-gray-800">
              <div className="flex gap-1">
                <span className="w-2 h-2 bg-gray-400 dark:bg-gray-500 rounded-full animate-bounce" />
                <span className="w-2 h-2 bg-gray-400 dark:bg-gray-500 rounded-full animate-bounce [animation-delay:0.1s]" />
                <span className="w-2 h-2 bg-gray-400 dark:bg-gray-500 rounded-full animate-bounce [animation-delay:0.2s]" />
              </div>
            </div>
          </div>
        )}
        <div ref={bottomRef} />
      </div>
      <ChatInput
        onSend={onSend}
        disabled={streaming}
        mode={mode}
        onVoiceGesture={onVoiceGesture}
        onStartVoice={onStartVoice}
      />
    </div>
  );
}
